import React, { useState, useCallback } from 'react'
import CryptoJS from 'crypto-js'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import EmailInput from '../../../global/components/forms/EmailInput.jsx'

import brandingName from '../../../global/enum/brandingName.jsx'
import apiUtils from '../../../global/utils/api.js'

const generatePKCEChallenge = () => {
  const buff = new Uint8Array(32)
  window.crypto.getRandomValues(buff)

  const codeVerifier = CryptoJS.lib.WordArray.create(buff)
  const codeChallenge = CryptoJS.SHA256(codeVerifier)

  return {
    verifier: CryptoJS.enc.Base64.stringify(codeVerifier),
    challenge: CryptoJS.enc.Base64.stringify(codeChallenge),
  }
}

const UserRegisterForm = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const [loading, setLoading] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [error, setError] = useState(null)

  const [email, setEmail] = useState('')

  const onEmailChange = useCallback(
    e => {
      setEmail(e.target.value)
    },
    [setEmail],
  )

  const onSignup = useCallback(
    async e => {
      e.preventDefault()
      setError(null)

      if (!executeRecaptcha) {
        alert('Can not validate captcha!')
        return
      }

      const pkce = generatePKCEChallenge()
      const captchaToken = await executeRecaptcha()

      setLoading(true)

      const result = await apiUtils.callAPI('/api/users/register', 'POST', {
        email: email,
        challenge: pkce.challenge,
        token: captchaToken,
      })

      setLoading(false)

      if (!result.success) {
        setError(result.message)
        return
      }

      localStorage.setItem('signup-verifier', pkce.verifier)
      setIsSubmitted(true)
    },
    [email, setIsSubmitted, setError, setLoading, executeRecaptcha],
  )

  return (
    <div
      className="form-container -skinny"
      style={{ marginTop: '64px' }}
    >
      <form
        className="user-form"
        onSubmit={onSignup}
      >
        <div style={{ maxWidth: '66%', margin: 'auto' }}>
          <img src={brandingName.image.logoBlack} />
        </div>
        <h2>Sign Up</h2>
        <hr />
        {!isSubmitted ? (
          <React.Fragment>
            <EmailInput
              name="email"
              label="Email Address"
              value={email}
              change={onEmailChange}
              required={true}
            />
            {error ? (
              <p style={{ color: '#FF2C2C', textAlign: 'center' }}>{error}</p>
            ) : null}
            <div className="input-group">
              <button
                className="yt-btn info block"
                type="submit"
                disabled={loading}
              >
                {loading ? 'Signing up...' : 'Sign up'}
              </button>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <p style={{ textAlign: 'center' }}>
              We've sent an email to the address <em>{email}</em>.
            </p>
            <p style={{ textAlign: 'center' }}>
              Please follow the instructions from there to finish setting up
              your account!
            </p>
          </React.Fragment>
        )}
      </form>
    </div>
  )
}

export default UserRegisterForm
